import { client } from '@/client';
import { resolveData } from '@/util/api-helpers';

export async function fetchTrades() {
   return client.get('/api/trades')
      .then(resolveData);
}

export async function addToBlacklist(slug, code) {
   return client.post(`api/trades/${slug}/blacklist/${code}`)
      .then(resolveData);
}

export async function removeFromBlacklist(slug, code) {
   return client.delete(`api/trades/${slug}/blacklist/${code}`)
      .then(resolveData);
}

export async function setBlacklist(slug, blacklist) {
   return client.post(`api/trades/${slug}/blacklist/set`, { blacklist })
      .then(resolveData);
}

export async function setWhitelist(slug, whitelist) {
   return client.post(`api/trades/${slug}/whitelist/set`, { whitelist })
      .then(resolveData);
}
